<template>
  <div class="module-table">
    <el-table :data="moduleData" border size="small" class="data-table">
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="纳税人名称" >
            <template slot-scope="scope">
              {{ scope.row.taxpayer_name || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="纳税人识别号">
            <template slot-scope="scope">
              {{ scope.row.taxpayer_identify_number || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="税种类型">
            <template slot-scope="scope">
              {{ scope.row.categories_of_taxes_type_name || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="以前欠税金额">
            <template slot-scope="scope">
              {{ scope.row.previous_tax_arrears_amount || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="本期欠税金额">
            <template slot-scope="scope">
              {{ scope.row.current_tax_arrears_amount || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="总欠税金额">
            <template slot-scope="scope">
              {{ scope.row.total_tax_arrears_forehead || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="所属税务机关">
            <template slot-scope="scope">
              {{ scope.row.belong_taxation_agency || '-' }}
            </template>
        </el-table-column>

    </el-table>
  </div>
</template>

<script>
export default {
    name: 'taxArrearsList',
    data() {
        return {
            title: '欠税信息',
        }
    },  
    props: {
        moduleData: {
            type: Array,
            default: () => []
        }
    },
    methods: {
    }
}
</script>

<style scoped lang="scss">
// 表格铺满
.module-table {
  width: 100%;
  .el-table { 
    width: 100%;
  }
}
</style>